import React from "react";
import "./Header.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";

function Header() {
	return (
		<header className="siteHeader">
			<div className="wrapper">
				<a className="siteLogo" href="/">
					OpenLava
				</a>
				<a className="exit-demo" href="//demo.openlava.com">
					<FontAwesomeIcon icon={faSignOutAlt} />
				</a>
			</div>
		</header>
	);
}

export default React.memo(Header);
